import { render, staticRenderFns } from "./AmazeVideoPlayer.vue?vue&type=template&id=240fa720"
import script from "./AmazeVideoPlayer.vue?vue&type=script&lang=js"
export * from "./AmazeVideoPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports